var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3031 39.3346H25.7576V43.8801H30.3031V39.3346Z",
    fill: "#808099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1819 39.3346H13.6364V43.8801H18.1819V39.3346Z",
    fill: "#808099"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 39.3346H7.57567V43.8801H12.1211V39.3346Z",
    fill: "#808099"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2424 39.3346H19.6969V43.8801H24.2424V39.3346Z",
    fill: "#808099"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4242 39.3346H37.8787V43.8801H42.4242V39.3346Z",
    fill: "#808099"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3637 39.3346H31.8182V43.8801H36.3637V39.3346Z",
    fill: "#808099"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7273 17.4848C22.7273 11.2181 17.6294 6.11975 11.3635 6.11975C5.09758 6.11975 0 11.2181 0 17.4848C0 27.6863 9.70667 34.1485 10.12 34.4187C10.4977 34.6655 10.9306 34.789 11.3635 34.789C11.7964 34.789 12.2292 34.6655 12.607 34.4187C12.6611 34.3834 13.9492 33.5361 15.5648 32.0308C18.8324 28.9872 22.7273 23.9929 22.7273 17.4848ZM12.4667 28.7051C12.0648 29.0794 11.6894 29.4032 11.3615 29.6726C9.09864 27.817 4.54545 23.3534 4.54545 17.4848C4.54545 13.7244 7.60394 10.6652 11.3635 10.6652C15.123 10.6652 18.1818 13.7244 18.1818 17.4848C18.1818 22.3582 15.0739 26.2763 12.4667 28.7051Z",
    fill: "#808099"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3636 20.5137C13.0372 20.5137 14.3939 19.157 14.3939 17.4834C14.3939 15.8098 13.0372 14.4531 11.3636 14.4531C9.69006 14.4531 8.33334 15.8098 8.33334 17.4834C8.33334 19.157 9.69006 20.5137 11.3636 20.5137Z",
    fill: "#808099"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6363 6.11975C32.3704 6.11975 27.2728 11.2181 27.2728 17.4848C27.2728 27.6863 36.9794 34.1485 37.3928 34.4187C37.7705 34.6655 38.2034 34.789 38.6363 34.789C39.0691 34.789 39.502 34.6655 39.8797 34.4187C39.9338 34.3834 41.222 33.5361 42.8378 32.0308C46.1052 28.9872 50.0001 23.9929 50.0001 17.4848C50.0001 11.2181 44.9022 6.11975 38.6363 6.11975ZM39.7394 28.7051C39.3376 29.0794 38.9622 29.4032 38.6343 29.6726C36.3714 27.817 31.8182 23.3534 31.8182 17.4848C31.8182 13.7244 34.8767 10.6652 38.6363 10.6652C42.396 10.6652 45.4546 13.7244 45.4546 17.4848C45.4546 22.3582 42.3467 26.2763 39.7394 28.7051Z",
    fill: "#808099"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6364 20.5137C40.31 20.5137 41.6667 19.157 41.6667 17.4834C41.6667 15.8098 40.31 14.4531 38.6364 14.4531C36.9629 14.4531 35.6061 15.8098 35.6061 17.4834C35.6061 19.157 36.9629 20.5137 38.6364 20.5137Z",
    fill: "#808099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.ebc121088d976e42af370ad24f817678.svg";
export { ForwardRef as ReactComponent };